import { useDrag, useDrop } from 'react-dnd';
import { useCallback } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import Discover from '../../../../common/redux/actions/DiscoverActions';
import { DnDTypes, VIZ_OPTION_IDS } from '../../../../common';
import { useVizOptionSelector } from '../../../../common/redux/selectors/viz-selector.hook';
import { findIndex } from 'lodash';

export const useColorGroupDnd = ({ item, vizId, toIndex }) => {
  const list = useVizOptionSelector({
    discoveryId: vizId,
    option: VIZ_OPTION_IDS.legendGroupMetadata,
    defaultValue: [],
  });
  const dispatch = useDispatch();

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: DnDTypes.COLOR_GROUP,
    drop: ({ id }: { id: string }) => {
      const fromIndex = findIndex(list, { id });

      if (fromIndex < 0 || fromIndex === toIndex) {
        return;
      }

      const newList = [...list];
      const [moved] = newList.splice(fromIndex, 1);
      newList.splice(toIndex, 0, moved);
      dispatch(Discover.updateVizLegendGroupData(vizId, newList));
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const [{ isDragging }, drag, preview] = useDrag({
    type: DnDTypes.COLOR_GROUP,
    item: { id: item.id },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const dropRef = useCallback(
    (element: HTMLElement | null) => {
      preview(drop(element));
    },
    [drop, preview],
  );

  const dragRef = useCallback(
    (element: HTMLElement | null) => {
      drag(element);
    },
    [drag],
  );

  const dndClasses = classnames({
    'drop-valid': isOver && canDrop,
    dragging: isDragging,
  });

  return {
    dragRef,
    dropRef,
    dndClasses,
  };
};
